// extracted by mini-css-extract-plugin
export default {"button":"Button_button__+Srl9","title":"Button_title__BjjYE"};